var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusPurpleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.982422,
    y: 1,
    width: 41,
    height: 41,
    rx: 20.5,
    fill: "white",
    stroke: "#B46C9F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8103 19.5222L19.7083 16.9042V13.1982H23.2782V16.9042L23.1083 19.5222L25.7943 19.3522H29.3303V22.8882H25.7943L23.1083 22.7862L23.2782 25.3362V29.2462H19.7083V25.3362L19.8103 22.7862L16.6823 22.8882H13.6562V19.3522H16.6823L19.8103 19.5222Z",
    fill: "#B46C9F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusPurpleIcon);
export default __webpack_public_path__ + "static/media/plusPurpleIcon.a286d11d18594afaba38f69ac2b8bc98.svg";
export { ForwardRef as ReactComponent };